import { PhosphorIconForExportOption } from "components/Atoms/PhosphorIcon";
import React from "react";
import { joinComponents } from "utilities/reactUtils";

interface Props {
  exportOption: server.dto.ExportOption
}

const ExportRowCard = (props: Props) => {
  return <div>
    <div className="s1_flagcell">
      <span className={props.exportOption.flagClass} />
    </div>
    <div className="grow1 flex-column gap-small">
      <div>
        {props.exportOption.title}
      </div>
      <div className="flex gap-small">
        <PhosphorIconForExportOption type={props.exportOption.exportTypes[0]} />
        <div>
          {joinComponents(props.exportOption.exportTypes[0].links.map((link, idx) => (
            <a key={idx} download href={link.url}>
              {link.label}
            </a>
          )), ", ")}
        </div>
      </div>
    </div>
  </div>;
};

export default ExportRowCard;